import {initP} from './voc-vars';
import {currentScript} from '../constants';
import DigitalContext from './digital-context';

var
  _gtm             = currentScript.getAttribute('data-legacy-gtm'),
  _googleAnalytics = currentScript.getAttribute('data-legacy-google-analytics'),
  _krux            = currentScript.getAttribute('data-legacy-krux'),
  _chartbeat       = currentScript.getAttribute('data-legacy-chartbeat'),
  _inspectlet      = currentScript.getAttribute('data-legacy-inspectlet'),
  _crazyegg        = currentScript.getAttribute('data-legacy-crazyegg'),
  _comscore        = currentScript.getAttribute('data-legacy-comscore'),
  _facebook        = currentScript.getAttribute('data-legacy-facebook')
;

export function snippets() {
  var promise;

  window.voc_krux = _krux; // FIXME: this is not the right place

  if (_krux || _chartbeat || _comscore) {promise = initP();}
  if (_krux) {
    promise.then(() => {
      window.context = DigitalContext.getContext();
      _kruxSnippet();
    });
  }
  if (_comscore)  {promise.then(() => _comscoreSnippet());}
  if (_chartbeat) {promise.then(() => _chartbeatSnippet());}
  if (_gtm)             {_gtmSnippet();}
  if (_googleAnalytics) {_googleanalyticsSnippet.init(_googleAnalytics).track();}
  if (_inspectlet)      {_inspectletSnippet();}
  if (_crazyegg)        {_crazyeggSnippet();}
  if (_facebook)        {_facebookSnippet.init(1234567890).track();}
}

export function trackLegacy() {
  // NOTE: call initP is not necessary by now
  if (_googleAnalytics) {_googleanalyticsSnippet.getInstance().track();}
  if (_facebook) {_facebookSnippet.getInstance().track();}
  if (_comscore) {_comscoreSnippet();}
}

/* Private */
var _googleanalyticsSnippet = (function () {
  let instance;
  let init = trackerId => {

    (function(i,s,o,g,r,a,m){i.GoogleAnalyticsObject=r;i[r]=i[r]||function(){
    (i[r].q=i[r].q||[]).push(arguments);},i[r].l=1*new Date();a=s.createElement(o),
    m=s.getElementsByTagName(o)[0];a.async=1;a.src=g;m.parentNode.insertBefore(a,m);
    })(window,document,'script','https://www.google-analytics.com/analytics.js','ga');

    window.ga('create', trackerId, 'auto');

    return {
      track: () => {
        window.ga('send', 'pageview');
      }
    };
  };

  return {
    init: (trackerId) => {
      if (!instance) {
        instance = init(trackerId);
      }
      return instance;
    },
    getInstance: () => {
      if (!instance) {
        throw Error('Google analytics wasn\'t initialized');
      }
      return instance;
    },
    flushInstance: () => {
      instance = undefined;
    }
  };
})();

var _facebookSnippet = (function () {
  let instance;
  let init = trackerId => {
    !function(f,b,e,v,n,t,s) {if(f.fbq)return;n=f.fbq=function(){n.callMethod?n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window,document,'script','https://connect.facebook.net/en_US/fbevents.js');
    window.fevents = true;
    window.fbq('init', trackerId);

    return {
      track: () => {
        window.fbq('track', 'PageView');
      }
    };
  };

  return {
    init: (trackerId) => {
      if (!instance) {
        instance = init(trackerId);
      }
      return instance;
    },
    getInstance: () => {
      if (!instance) {
        throw Error('facebook tracking wasn\'t initialized');
      }
      return instance;
    },
    flushInstance: () => {
      instance = undefined;
    }
  };
})();

function _comscoreSnippet() {
   function udm_(e) { /* jshint ignore:line */
    if (typeof window.c7 === 'undefined' || window.c7 === '') {
      var t = 'comScore=',n=document,r=n.cookie,i='',s='indexOf',o='substring',u='length',a=2048,f,l='&ns_',c='&',h,p,d,v,m=window,g=m.encodeURIComponent||escape;if(r[s](t)+1)for(d=0,p=r.split(';'),v=p[u];d<v;d++)h=p[d][s](t),h+1&&(i=c+window.unescape(p[d][o](h+t[u])));e+=l+'_t='+ +(new Date)+l+'c='+(n.characterSet||n.defaultCharset||'')+'&c8='+g(n.title)+i+'&c7='+g(n.URL)+'&c9='+g(n.referrer),e[u]>a&&e[s](c)>0&&(f=e[o](0,a-8).lastIndexOf(c),e=(e[o](0,f)+l+'cut='+g(e[o](f+1)))[o](0,a)),n.images?(h=new Image,m.ns_p||(window.ns_p=h),h.src=e):n.write('<','p','><','img src="',e,'" height="1" width="1" alt="*"','><','/p','>');
    } else {
      var t = 'comScore=',n=document,r=n.cookie,i='',s='indexOf',o='substring',u='length',a=2048,f,l='&ns_',c='&',h,p,d,v,m=window,g=m.encodeURIComponent||escape;if(r[s](t)+1)for(d=0,p=r.split(';'),v=p[u];d<v;d++)h=p[d][s](t),h+1&&(i=c+window.unescape(p[d][o](h+t[u])));e+=l+'_t='+ +(new Date)+l+'c='+(n.characterSet||n.defaultCharset||'')+'&c8='+g(n.title)+i+'&c9='+g(n.referrer),e[u]>a&&e[s](c)>0&&(f=e[o](0,a-8).lastIndexOf(c),e=(e[o](0,f)+l+'cut='+g(e[o](f+1)))[o](0,a)),n.images?(h=new Image,m.ns_p||(window.ns_p=h),h.src=e):n.write('<','p','><','img src="',e,'" height="1" width="1" alt="*"','><','/p','>');
    }
  }

  if (!window.c7) {
    udm_('http'+(document.location.href.charAt(4)=='s'?'s://sb':'://b')+'.scorecardresearch.com/b?c1=2&c2=' + _comscore + '&ns_site='+ns_site+'&name='+window.voc_name+'&voc_site='+window.voc_site+'&voc_se='+window.voc_se+'&voc_s1='+window.voc_s1+'&voc_s2='+window.voc_s2+'&voc_s3='+window.voc_s3+'&voc_s4='+window.voc_s4+'&voc_tn='+window.voc_tn+'&voc_ho='+window.voc_ho+'&voc_tc='+window.voc_tc+'&voc_ed='+window.voc_ed+'&voc_au='+window.voc_au+'&voc_fep='+window.voc_fep+'&voc_fem='+window.voc_fem+'&voc_or='+window.voc_or+'&voc_pr='+window.voc_pr+'&voc_pl='+window.voc_pl+'&voc_pu='+window.voc_pu+'&voc_usrid='+window.voc_usrid+'&voc_tusr='+window.voc_tusr+'&voc_ate='+window.voc_ate+'&voc_idi='+window.voc_idi+'&voc_usrag='+window.voc_usrag+'&voc_usrcp='+window.voc_usrcp+'&voc_usrgen='+window.voc_usrgen+'&voc_pw_pid='+window.voc_pw_pid+'&voc_pw_meter='+window.voc_pw_meter+'&voc_pw_count='+window.voc_pw_count+'&voc_pw_max='+window.voc_pw_max+'&voc_pw_result='+window.voc_pw_result+'&voc_pw_cookie='+window.voc_pw_cookie+'&ns_http_status='+ns_http_status+'&voc_adp='+window.voc_adp+'&voc_usrser='+window.voc_usrser+'&voc_usrsvs='+window.voc_usrsvs+'&voc_adb='+window.voc_adb+'&voc_krux='+window.voc_krux);
  } else {
    udm_('http'+(document.location.href.charAt(4)=='s'?'s://sb':'://b')+'.scorecardresearch.com/b?c1=2&c2=' + _comscore + '&ns_site='+ns_site+'&name='+window.voc_name+'&voc_site='+window.voc_site+'&voc_se='+window.voc_se+'&voc_s1='+window.voc_s1+'&voc_s2='+window.voc_s2+'&voc_s3='+window.voc_s3+'&voc_s4='+window.voc_s4+'&voc_tn='+window.voc_tn+'&voc_ho='+window.voc_ho+'&voc_tc='+window.voc_tc+'&voc_ed='+window.voc_ed+'&voc_au='+window.voc_au+'&voc_fep='+window.voc_fep+'&voc_fem='+window.voc_fem+'&voc_or='+window.voc_or+'&voc_pr='+window.voc_pr+'&voc_pl='+window.voc_pl+'&voc_pu='+window.voc_pu+'&voc_usrid='+window.voc_usrid+'&voc_tusr='+window.voc_tusr+'&voc_ate='+window.voc_ate+'&voc_idi='+window.voc_idi+'&voc_usrag='+window.voc_usrag+'&voc_usrcp='+window.voc_usrcp+'&voc_usrgen='+window.voc_usrgen+'&voc_pw_pid='+window.voc_pw_pid+'&voc_pw_meter='+window.voc_pw_meter+'&voc_pw_count='+window.voc_pw_count+'&voc_pw_max='+window.voc_pw_max+'&voc_pw_result='+window.voc_pw_result+'&voc_pw_cookie='+window.voc_pw_cookie+'&ns_http_status='+ns_http_status+'&c7='+window.c7+'&voc_adp='+window.voc_adp+'&voc_usrser='+window.voc_usrser+'&voc_usrsvs='+window.voc_usrsvs+'&voc_adb='+window.voc_adb+'&voc_krux='+window.voc_krux);
  }
}

function _gtmSnippet() {
  // NOTE: dataLayer?
  (function(w,d,s,l,i) {
    w[l]=w[l]||[];
    w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});
    var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';
    j.async=true;
    j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;
    f.parentNode.insertBefore(j,f);
  })(window, document, 'script', 'dataLayer', _gtm);
}

function _kruxSnippet() {
  currentScript.className = 'kxct';
  currentScript.setAttribute('data-id', _krux);
  currentScript.setAttribute('data-timing', 'async');
  currentScript.setAttribute('data-version', '3.0');

  window.Krux||((window.Krux=function(){window.Krux.q.push(arguments);}).q=[]);
  (function(){
    var k=document.createElement('script');k.type='text/javascript';k.async=true;
    k.src=(document.location.protocol==='https:'?'https:':'http:')+'//cdn.krxd.net/controltag/'+_krux+'.js';
    var s=document.getElementsByTagName('script')[0];s.parentNode.insertBefore(k,s);
  }());

//  window.Krux || ((window.Krux = function() {window.Krux.q.push(arguments);}).q = []);
//
//  (function IIFE(){
//    var k = document.createElement('script');
//    k.type = 'text/javascript';
//    k.async = true;
//    var m, src = (m = document.location.href.match(/\bkxsrc=([^&]+)/)) && decodeURIComponent(m[1]); /* jshint ignore:line */
//    k.src = /^https?:\/\/([^\/]+\.)?krxd\.net(:\d{1,5})?\//i.test(src) ? src : src === 'disable' ? '' : (location.protocol === 'https:' ? 'https:' : 'http:') + '//cdn.krxd.net/controltag?confid=' + _krux;
//    var s = document.getElementsByTagName('script')[0];
//    s.parentNode.insertBefore(k, s);
//  }());

  // TODO: preguntar por el snippet de conexión con DFP
}

function _chartbeatSnippet() {
  window._sf_async_config          = {};
  window._sf_async_config.uid      = _chartbeat;
  window._sf_async_config.domain   = window.vocento.site.tlddomain; // FIXME
  window._sf_async_config.sections = '' + ((window.voc_s4 !== '') ? window.voc_s4 + ',' : '') + ((window.voc_s3 !== '') ? window.voc_s3 + ',' : '')+ ((window.voc_s2 !== '') ? window.voc_s2 + ',' : '') + ((window.voc_s1 !== '') ? window.voc_s1 + ',' : '') + window.voc_se;
  window._sf_async_config.authors  = '' + window.voc_au;

  (function IIFE() {
    function loadChartbeat() {
      window._sf_endpt = (new Date()).getTime();
      var e = document.createElement('script');
      e.setAttribute('language', 'javascript');
      e.setAttribute('type', 'text/javascript');
      e.setAttribute('src', (('https:' == document.location.protocol) ? 'https://a248.e.akamai.net/chartbeat.download.akamai.com/102508/' : 'http://static.chartbeat.com/') + 'js/chartbeat.js');
      document.body.appendChild(e);
    }
    var oldonload = window.onload;
    window.onload = (typeof window.onload != 'function') ? loadChartbeat : function() {
      oldonload();
      loadChartbeat();
    };
  })();
}

function _inspectletSnippet() {
  window.__insp = window.__insp || [];
  window.__insp.push(['wid', _inspectlet]);

  (function IIFE() {
    function ldinsp() {
      if (typeof window.__inspld != 'undefined') {return;}
      window.__inspld = 1;
      var insp = document.createElement('script');
      insp.type = 'text/javascript';
      insp.async = true;
      insp.id = 'inspsync';
      insp.src = ('https:' == document.location.protocol ? 'https' : 'http') + '://cdn.inspectlet.com/inspectlet.js';
      var x = document.getElementsByTagName('script')[0];
      x.parentNode.insertBefore(insp, x);
    }
    setTimeout(ldinsp, 500);
    document.readyState != 'complete' ? (window.attachEvent ? window.attachEvent('onload', ldinsp) : window.addEventListener('load', ldinsp, false)) : ldinsp();
  })();
}

function _crazyeggSnippet() {
  setTimeout(function() {
    var a = document.createElement('script');
    var b = document.getElementsByTagName('script')[0];
    a.src = document.location.protocol + '//script.crazyegg.com/pages/scripts/' + _crazyegg + '.js?' + Math.floor(new Date().getTime() / 3600000);
    a.async=true;a.type = 'text/javascript';
    b.parentNode.insertBefore(a, b);
  }, 1);
}



// WEBPACK FOOTER //
// ./src/legacy/snippets.js